<template>
  <div :class="$style.wrapper" @mousemove="doDrag">
    <div :class="$style.dashboard">
      <div :class="$style.dashboard__count">
        <span>{{interestsFoundCount}}</span>
        <span :class="$style.dashboard__from">из</span>
        <span class="">{{interestsList.length}}</span>
      </div>
      <span :class="$style.dashboard__title">Найдено общих интересов</span>
    </div>
    <div :class="$style.interests">
      <div :class="[$style.interests__group, $style.top]" class="group-top">
        <div
          v-for="(item, index) in topPersonInterestsList"
          :key="index"
          :class="[$style.item, selectedTop === index && 'selected', selectedTop === index && wrongConnection && 'wrong', item.some(x => interestsFound.includes(x))  && 'right']"
          class="item pointer"
          @mouseup="dragSelect(index, 'top')"
          @mousedown="startDrag($event, index, 'top')"
        >
          <div :class="$style.item__face">
            <img :src="require(`@/assets/lesson-1/interestsTask/face_${index+1}.svg`)"/>
          </div>
          <div :class="$style.item__interestsList">
            <div :class="$style.interestsListItem" v-for="(interest, id) in item" :key="id">
              <span :class="$style.interestTitle">{{interestsList.filter(n => n.id === interest)[0].title}}</span>
              <img :src="require(`@/assets/lesson-1/interestsTask/interest_${interest}.png`)"/>
            </div>
          </div>
          <div :ref="`top_connection_${index}`" :class="$style.item__connection" class="connection" :data-id="index"></div>
        </div>
      </div>
      <div :class="[$style.interests__group, $style.bottom]" class="group-bottom">
        <div
          v-for="(item, index) in bottomPersonInterestsList"
          :key="index"
          :class="[$style.item, selectedBottom === index && 'selected', selectedBottom === index && wrongConnection && 'wrong', item.some(x => interestsFound.includes(x)) && 'right']"
          class="item pointer"
          @mouseup="dragSelect(index, 'bottom')"
          @mousedown="startDrag($event, index, 'bottom')"
        >
          <div :class="$style.item__face">
            <img :src="require(`@/assets/lesson-1/interestsTask/face_${index+middleInterestsListIndex+1}.svg`)"/>
          </div>
          <div :class="$style.item__interestsList">
            <div :class="$style.interestsListItem" v-for="(interest, id) in item" :key="id">
              <span :class="$style.interestTitle">{{interestsList.filter(n => n.id === interest)[0].title}}</span>
              <img :src="require(`@/assets/lesson-1/interestsTask/interest_${interest}.png`)"/>
            </div>
          </div>
          <div :ref="`bottom_connection_${index}`" :class="$style.item__connection" class="connection" :data-id="index+middleInterestsListIndex"></div>
        </div>
      </div>
    </div>
    <svg id="svg"></svg>
  </div>
</template>

<script>
import SvgLines from '@/components/SvgLines/SvgLines'

export default {
  name: 'ConnectInterestsTask',
  components: {
  },
  data: () => ({
    interestsList: [
      { id: 1, title: 'Шарики' },
      { id: 2, title: 'Фрукты' },
      { id: 3, title: 'Путешествия' },
      { id: 4, title: 'Машины' },
      { id: 5, title: 'Музыка' },
      { id: 6, title: 'Космос' },
      { id: 7, title: 'Футбол' },
      { id: 8, title: 'Велосипед' },
      { id: 9, title: 'Мороженное' },
      { id: 10, title: 'Компьютерные игры' },
      { id: 11, title: 'Животные' },
      { id: 12, title: 'Рисование' },
    ],
    personInterests: [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12], [8, 5, 11], [6, 3, 10], [12, 7, 1], [9, 4, 2]],
    interestsFound: [],
    wrongConnection: false,
    svgLines: null,
    dragging: false,
    x: null,
    y: null,
    draggingElement: null,
    selectedTop: null,
    selectedBottom: null,
  }),
  computed: {
    interestsFoundCount() {
      return this.interestsFound.length
    },
    middleInterestsListIndex() {
      return Math.ceil(this.personInterests.length / 2)
    },
    topPersonInterestsList() {
      return this.personInterests.slice(0, this.middleInterestsListIndex)
    },
    bottomPersonInterestsList() {
      return this.personInterests.slice(this.middleInterestsListIndex, this.personInterests.length)
    },
  },
  methods: {
    init() {
      this.setRandomInterests()
      const svg = document.querySelector('#svg')
      window.addEventListener('mouseup', this.stopDrag)
      this.svgLines = new SvgLines(svg)
    },
    setRandomInterests() {
      this.personInterests.forEach(el => this.shuffle(el))
      this.personInterests = this.shuffle(this.topPersonInterestsList).concat(this.shuffle(this.bottomPersonInterestsList))
    },
    shuffle(arr) {
      let j
      let temp
      for (let i = arr.length - 1; i > 0; i -= 1) {
        j = Math.floor(Math.random() * (i + 1))
        temp = arr[j]
        arr[j] = arr[i]
        arr[i] = temp
      }
      return arr
    },
    checkConnection() {
      const { selectedTop, selectedBottom, $refs } = this

      if (selectedTop === null || selectedBottom === null) return

      const topPoint = $refs[`top_connection_${selectedTop}`][0]
      const bottomPoint = $refs[`bottom_connection_${selectedBottom}`][0]

      const personTopInterests = this.personInterests[selectedTop]
      const personBottomInterests = this.personInterests[selectedBottom + this.middleInterestsListIndex]
      const intersection = personTopInterests.filter(x => personBottomInterests.includes(x))

      if (intersection.length) {
        this.svgLines.addRight(topPoint, bottomPoint)
        this.selectedTop = null
        this.selectedBottom = null
        if (this.interestsFound.includes(intersection[0])) return
        this.interestsFound.push(intersection[0])
        this.$emit('addPoint')
        if (this.interestsFound.length === this.interestsList.length && !this.wrongConnection) {
          this.$emit('success')
        }
      } else {
        this.svgLines.addWrong(topPoint, bottomPoint)
        this.wrongConnection = true
        this.$emit('warning')
      }
    },
    closeWarning() {
      this.svgLines.removeLast()
      this.selectedTop = null
      this.selectedBottom = null
      this.wrongConnection = false
      if (this.interestsFound.length === this.interestsList.length) this.$emit('success')
      else this.$emit('help')
    },
    startDrag(event, index, side) {
      if (this.wrongConnection) {
        this.closeWarning()
        return
      }

      if (side === 'bottom') {
        this.selectedBottom = index
      } else {
        this.selectedTop = index
      }

      this.dragging = true
      this.x = 0
      this.y = 0
      this.draggingElement = event.currentTarget.querySelector('.connection')
    },
    stopDrag() {
      this.dragging = false
      this.x = null
      this.y = null
      this.draggingElement = null
      this.svgLines.removePoint()
    },
    dragSelect(index, side) {
      if (this.wrongConnection) {
        this.closeWarning()
        return
      }

      if (side === 'bottom') {
        this.selectedBottom = index
      } else {
        this.selectedTop = index
      }

      this.dragging = false
      this.x = null
      this.y = null
      this.draggingElement = null
      this.svgLines.removePoint()

      this.checkConnection()
    },
    doDrag(event) {
      if (this.dragging) {
        this.x = event.clientX
        this.y = event.clientY
        this.svgLines.setPoint(this.draggingElement, this.x, this.y)
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" module>
  @import './ConnectInterestsTask.scss';
</style>
